import { useMutation } from '@tanstack/react-query';

import {
  IOrderConfirmRequestDto,
  orderConfirm,
} from '@/shared/api/subscriptions';

export function useOrderConfirmation() {
  const createMutation = useMutation({
    mutationFn: (data: IOrderConfirmRequestDto) => orderConfirm(data),
  });

  const confirmOrder = (data: IOrderConfirmRequestDto) =>
    createMutation.mutateAsync(data);

  return { confirmOrder, ...createMutation };
}
